/* MSC Clean Lux - theme JS */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    // Mobile menu toggle
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var isOpen = !nav.hidden;
        nav.hidden = isOpen;
        toggle.setAttribute('aria-expanded', String(!isOpen));
      });
    }

    // Product form: enable/disable add-to-cart based on variant availability
    var variantSelect = document.getElementById('VariantSelect');
    var addButton = document.querySelector('[data-product-form-root] button[name="add"]');
    if (variantSelect && addButton) {
      variantSelect.addEventListener('change', function () {
        var selected = variantSelect.options[variantSelect.selectedIndex];
        var disabled = selected && selected.disabled;
        addButton.disabled = disabled;
        addButton.textContent = disabled ? addButton.dataset.soldOutText || 'Sold out' : addButton.dataset.addToCartText || 'Add to cart';
      });
    }

    // Auto-submit quantity-based cart updates on change
    var cartForm = document.querySelector('.cart-form');
    if (cartForm) {
      cartForm.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
        input.addEventListener('change', function () {
          cartForm.submit();
        });
      });
    }
  });
})();
